<template>
  <div>
    <a-drawer
      title="新增客户"
      placement="right"
      width="800"
      :closable="false"
      @close="onClose"
      :visible="visible"
      :maskClosable="false"
    >
      <a-form :form="form" @submit="saveColumnData">
        <a-divider orientation="left">账号信息</a-divider>
        <!-- <a-form-item
          label="客户编码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'code',
              {
                rules: [{ required: true, message: '请输入客户编码' }]
              }
            ]"
            placeholder="请输入客户编码"/>
        </a-form-item> -->
        <a-form-item
          label="客户名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '请输入客户名称' }]
              }
            ]"
            placeholder="请输入客户名称"/>
        </a-form-item>
        <a-form-item
          label="联系人名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'contacts',
              {
                rules: [{ required: true, message: '请输入联系人名称' }]
              }
            ]"
            placeholder="请输入联系人名称"/>
        </a-form-item>
        <a-form-item
          label="联系人电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'contact_number',
              {
                rules: [{ required: true, message: '请输入联系人电话' }]
              }
            ]"
            placeholder="请输入联系人电话"/>
        </a-form-item>
        <a-form-item
          label="登录账号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'account',
              {
                rules: [{ required: true, message: '请输入登录账号' }]
              }
            ]"
            placeholder="请输入登录账号"/>
        </a-form-item>
        <a-form-item
          label="登录密码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'password',
              {
                rules: [{ required: true, message: '请输入登录密码' }]
              }
            ]"
            placeholder="请输入登录密码"/>
        </a-form-item>
        <a-form-item
          :required="true"
          label="会员类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="addData.code_type">
            <a-radio-button v-if="type.id !== ''" v-for="type in dict.codeTypeDict" :value="type.id" :key="type.id">{{ type.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          :required="true"
          label="账号状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group v-model="addData.status">
            <a-radio-button v-if="status.id !== ''" v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="业务经理"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'business_admin_id',
              {
                initialValue: dict.admin_id,
              }
            ]"
            placeholder="请选择">
            <a-select-option v-for="item in dict.businessManagerDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          :required="true"
          label="选择服务"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            mode="multiple"
            v-decorator="[
              'service'
            ]"
            placeholder="请选择服务">
            <a-select-option v-for="item in dict.serviceDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-divider orientation="left">企业信息</a-divider>
        <a-form-item
          label="企业全称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'system_name'
            ]"
            placeholder="请输入企业全称"/>
        </a-form-item>
        <a-form-item
          label="企业简称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'system_short_name',
              {
                rules: [{ required: true, message: '请输入企业简称' }]
              }
            ]"
            placeholder="请输入企业简称"/>
        </a-form-item>
        <a-form-item
          label="企业LOGO"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol">
          <a-upload
            name="file"
            :defaultFileList="fileList"
            listType="picture-card"
            class="avatar-uploader"
            :showUploadList="false"
            action="/admin.php/upload_file/uploadFile?type=tenant&local=YES"
            @change="handleChange"
          >
            <img v-if="logoUrl" :src="logoUrl" style="width:150px;" alt="LOGO" />
            <div v-else>
              <a-icon :type="loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item
          label="官网地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'system_url'
            ]"
            placeholder="请输入官网地址"/>
        </a-form-item>
        <a-form-item
          label="联系电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'phone'
            ]"
            placeholder="请输入联系电话"/>
        </a-form-item>
        <a-form-item
          label="联系QQ"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'qq_number'
            ]"
            placeholder="请输入联系QQ"/>
        </a-form-item>
        <a-form-item
          label="联系邮箱"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'email'
            ]"
            placeholder="请输入联系邮箱"/>
        </a-form-item>
        <a-form-item
          label="联系地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'address'
            ]"
            placeholder="请输入联系地址"/>
        </a-form-item>
        <a-form-item :wrapperCol="{span: 12, offset: 9}">
          <a-button style="margin-right:20px" html-type="submit" type="primary" :loading="loading">创建</a-button>
          <a-button @click="onClose">取消</a-button>
        </a-form-item>
      </a-form>
    </a-drawer>
  </div>
</template>
<script>
import { getPre, addTenant } from '@/api/tenant'
import _ from 'lodash'
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.handelPre()
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 4 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 20 }, sm: { span: 19 } },
      // 按钮加载
      loading: false,
      // 添加数据
      addData: {},
      dict: {},
      fileList: [],
      logoUrl: ''
    }
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    onExpiryTimeChange (date, dateString) {
      this.addData.expiry_time = dateString
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.addData[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 图片上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const picUrl = _.get(info.file, 'response.data.url')
        this.addData[targetId] = path
        if (targetId === 'system_logo') {
          this.logoUrl = picUrl
        }
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleChange (info) {
      this.handleFileUpload(info, 'system_logo')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.addData.name = fieldsValue['name']
          // this.addData.code = fieldsValue['code']
          this.addData.contacts = fieldsValue['contacts']
          this.addData.contact_number = fieldsValue['contact_number']
          this.addData.business_admin_id = fieldsValue['business_admin_id']
          this.addData.service = fieldsValue['service']
          this.addData.account = fieldsValue['account']
          this.addData.password = fieldsValue['password']
          this.addData.system_name = fieldsValue['system_name']
          this.addData.system_short_name = fieldsValue['system_short_name']
          this.addData.qq_number = fieldsValue['qq_number']
          this.addData.address = fieldsValue['address']
          this.addData.phone = fieldsValue['phone']
          this.addData.email = fieldsValue['email']
          this.addData.system_url = fieldsValue['system_url']
          addTenant(this.addData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.loading = false
              this.$message.success('客户创建成功')
              setTimeout(() => { this.$emit('finish') }, '500')
            } else {
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      })
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
